import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('../views/index.vue'),
    meta: {
      title: "网站首页",
      index: 0,
      footShow: true,
      headShow: true
    }
  }, {
    path: '/companyDetails',
    name: 'companyDetails',
    component: () => import('../views/companyDetails.vue'),
    meta: {
      title: "公司介绍",
      index: 0,
      footShow: false,
      headShow: true
    }
  }, {
    path: '/eliminationList',
    name: 'eliminationList',
    component: () => import('../views/eliminationList.vue'),
    meta: {
      title: "汰汰清单",
      index: 2,
      footShow: true,
      headShow: true
    }
  }, {
    path: '/eliminationListDetails',
    name: 'eliminationListDetails',
    component: () => import('../views/eliminationListDetails.vue'),
    meta: {
      title: "汰汰清单详情",
      index: 2,
      footShow: false,
      headShow: true
    }
  }, {
    path: '/downloadApp',
    name: 'downloadApp',
    component: () => import('../views/downloadApp.vue'),
    meta: {
      title: "汰汰清单下载",
      index: 2,
      footShow: false,
      headShow: true
    }
  }, {
    path: '/orderPrinting',
    name: 'orderPrinting',
    component: () => import('../views/orderPrinting.vue'),
    meta: {
      title: "店星人",
      index: 3,
      footShow: true,
      headShow: true
    }
  }, {
    path: '/orderPrintingDetails',
    name: 'orderPrintingDetails',
    component: () => import('../views/orderPrintingDetails.vue'),
    meta: {
      title: "店星人打单详情",
      index: 3,
      footShow: false,
      headShow: true
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  //页面跳转显示在顶部   
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局前置守卫：任何页面的访问都要经过这里
// to：要去哪里的路由信息
// from：从哪里来的路由信息
// next：通行的标志
// router.beforeEach((to, from, next) => {
//   document.title = '无尽起源';
//   next()
// })


// 解决重复点击相同路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
